export const TAB_ID = {
  REVIEWS: 'reviews',
  ROOM_LIST: 'roomList',
  PLAN_LIST: 'planList',
  ROOMS_AND_PLANS: 'roomsAndPlans',
  OVERVIEW: 'overview',
  HIGHLIGHTS: 'highlights',
  INFO: 'info',
};
